// extracted by mini-css-extract-plugin
export default {"resCont":"result_resCont__7nnNG","result":"result_result__dxnTf","image":"result_image__m7qHg","resultCont":"result_resultCont__xBKxd"};